import { render } from "./OpenSeaIcon.vue?vue&type=template&id=3b15033c"
const script = {}

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__